/**
 * Cantidad en las tarjetas de un solo peso.
 *
 * Las tarjetas con selector de peso traen su caja gris justo bajo el precio;
 * las de un solo formato quedaban con el precio y despues un hueco hasta el
 * boton. Y peor: obligaban a apretar "Agregar al carrito" una vez por unidad,
 * cosa absurda en cortes que se venden por pieza (chuleta, alitas, pollo).
 *
 * Segundo intento. El primero fabricaba una caja parecida y la metia dentro
 * del <form>, en .quick-add. Quedaba unos 30 px mas abajo que la de "Peso:"
 * porque son contenedores distintos: el selector de peso vive en
 * .card-information y ahi recibe overrides que solo existen dentro del
 * carrusel (.slider .card__information ... margin-top 1rem, y en escritorio
 * .slider--desktop .grid__item ... padding lateral 0.6rem). Copiar los
 * valores de adentro no alcanza si el de afuera no es el mismo.
 *
 * Asi que ahora no imito la caja: uso la misma. Mismas clases
 * (.card-product__variant-selector > .card-variant-option > .card-variant-select),
 * mismo padre (.card-information, justo despues del precio), misma posicion.
 * No hay nada que medir ni que compensar; si el tema cambia el estilo de una,
 * cambia el de las dos.
 *
 * Reparto de responsabilidades para no depender del atributo form=""
 * ni de como el navegador arma FormData:
 *   - el <select> visible va en .card-information, fuera del <form>;
 *   - un <input type="hidden" name="quantity"> va DENTRO del <form> y se
 *     sincroniza en cada change.
 * product-form.js arma el pedido con new FormData(this.form), o sea que lee
 * el hidden, que es hijo directo del form. No se toca la logica de carrito.
 *
 * Quien podria pisarnos, revisado:
 *   - card-direct-add-to-cart.js filtra por .card-variant-select[data-update-form="true"];
 *     este select no lleva ese atributo, no lo ve.
 *   - card-variant-selector.js (legacy) si engancha un change, pero su
 *     handler sale en seco con if (!variantPrice) return; y estas opciones no
 *     tienen data-variant-price.
 *
 * Si este script falla, la tarjeta sigue funcionando: sin campo quantity
 * Shopify asume 1, que es el comportamiento de siempre.
 */
(function () {
  var MAXIMO = 10;
  var observador = null;

  function poner(form) {
    try {
      if (form.dataset.cantidadLista) return;

      var tarjeta = form.closest('.card-wrapper');
      if (!tarjeta) return;

      // Las que ya tienen selector de peso no llevan cantidad: esa caja ocupa
      // ese lugar y el peso ya es la decision principal. Busco el select real
      // del tema por su atributo, no por el contenedor, porque el contenedor
      // ahora tambien lo usa esta caja.
      if (tarjeta.querySelector('.card-variant-select[data-update-form="true"]')) {
        form.dataset.cantidadLista = '1';
        return;
      }
      if (form.querySelector('[name="quantity"]')) {
        form.dataset.cantidadLista = '1';
        return;
      }
      if (tarjeta.querySelector('[data-mp-cantidad]')) {
        form.dataset.cantidadLista = '1';
        return;
      }

      var boton = form.querySelector('.quick-add__submit');
      if (!boton) return;

      // Mismo punto que el selector de peso: dentro de .card-information,
      // inmediatamente despues del precio.
      var precio = tarjeta.querySelector('.card-information .price');
      var destino = precio ? precio.parentNode : tarjeta.querySelector('.card-information');
      if (!destino) return;

      // 1. El campo que realmente viaja al carrito, hijo del form.
      var oculto = document.createElement('input');
      oculto.type = 'hidden';
      oculto.name = 'quantity';
      oculto.value = '1';
      form.appendChild(oculto);

      // 2. El control que ve el cliente, con el marcado del tema.
      var caja = document.createElement('div');
      caja.className = 'card-product__variant-selector';
      caja.setAttribute('data-mp-cantidad', '1');

      var fila = document.createElement('div');
      fila.className = 'card-variant-option';
      // El ::before del tema imprime "Cantidad:" con la misma tipografia que
      // "Peso:". Por eso la etiqueta va aca y no en un <label> aparte.
      fila.setAttribute('data-option-name', 'Cantidad');

      var sel = document.createElement('select');
      sel.className = 'card-variant-select';
      sel.setAttribute('aria-label', 'Cantidad');
      for (var i = 1; i <= MAXIMO; i++) {
        var op = document.createElement('option');
        op.value = String(i);
        op.textContent = i === 1 ? '1 unidad' : i + ' unidades';
        sel.appendChild(op);
      }
      // Si el boton esta deshabilitado la caja se ve igual pero no se toca:
      // la tarjeta mantiene el alto y no ofrece algo que no se puede hacer.
      if (boton.disabled) sel.disabled = true;

      sel.addEventListener('change', function () {
        oculto.value = sel.value;
      });

      fila.appendChild(sel);
      caja.appendChild(fila);

      if (precio) {
        destino.insertBefore(caja, precio.nextSibling);
      } else {
        destino.appendChild(caja);
      }

      form.dataset.cantidadLista = '1';
    } catch (e) {
      /* silencio a proposito: nunca romper el add to cart */
    }
  }

  function pasada() {
    // Me desconecto durante la pasada: inserto nodos y no quiero que el
    // observador se dispare a si mismo.
    if (observador) observador.disconnect();
    try {
      document.querySelectorAll('product-form form').forEach(poner);
    } catch (e) {
      /* idem */
    }
    if (observador) observador.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pasada);
  } else {
    pasada();
  }

  document.addEventListener('shopify:section:load', pasada);
  document.addEventListener('slider:change', function () { setTimeout(pasada, 100); });

  if (window.MutationObserver) {
    var pendiente = null;
    observador = new MutationObserver(function (mutaciones) {
      for (var i = 0; i < mutaciones.length; i++) {
        if (mutaciones[i].addedNodes.length) {
          clearTimeout(pendiente);
          pendiente = setTimeout(pasada, 200);
          return;
        }
      }
    });
    observador.observe(document.body, { childList: true, subtree: true });
  }
})();
